import React from 'react'
import VisDiv from '../frontend_components/VisDiv'
import Link from 'next/link'

/**
 * ManagementSidebar component
 * 
 * This component renders a sidebar with links to clients and sites pages
 * #anagraficheManagement
 * #registerManagement
 * @returns {JSX.Element} The rendered component
 */
const ManagementSidebar = () => {
  return (  
    <VisDiv className="sideBar">
        <SidebarItem link="clients" title="CLIENTI"/>
        <SidebarItem link="sites" title="PLESSI"/>
    </VisDiv>
  )
}

export default ManagementSidebar


/**
 * SidebarItem component
 * #anagraficheManagement
 * #reports
 * This component renders a single item in the sidebar, with a link to the given page
 * 
 * @param {string} link - The link to the page
 * @param {string} title - The title of the link
 * @returns {JSX.Element} The rendered component
 */
export const SidebarItem = ({link, title}) => {
    return (
        <VisDiv className={"sidebar-item"} href="./management/clients">
            <Link href={`/management/${link}`}>
                <p>{title}</p>
            </Link>
        </VisDiv>
    )
}
